// src/components/footer4.js
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import './footer4.css'
import { useTranslation } from 'react-i18next'
import MercaditoLogo from '../assets/MercaditoAI_Logo.jpg'

const Footer4 = ({
  link1 = undefined,
  link2 = undefined,
  link3 = undefined,
  link4 = undefined,
  link5 = undefined,
  termsLink = undefined,
  cookiesLink = undefined,
  privacyLink = undefined,
  logoAlt = 'Mercadito AI Logo',
  logoSrc = MercaditoLogo,
}) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer4-section thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        
        {/* Top: Logo & Main Navigation Links */}
        <div className="footer4-top">
          <a href="/" className="footer4-logo-wrap">
            <img
              alt={logoAlt}
              src={logoSrc}
              className="footer4-logo"
            />
            <span className="footer4-brand-text">Mercadito AI</span>
          </a>

          <div className="footer4-links">
            <a href="/" className="footer4-link thq-body-small">
              {link1 ?? (
                <Fragment>
                  <span>{t('home.footer.link1', 'Home')}</span>
                </Fragment>
              )}
            </a>
            <a href="#features" className="footer4-link thq-body-small">
              {link2 ?? (
                <Fragment>
                  <span>{t('home.footer.link2', 'Features')}</span>
                </Fragment>
              )}
            </a>
            <a href="#how-it-works" className="footer4-link thq-body-small">
              {link3 ?? (
                <Fragment>
                  <span>{t('home.footer.link3', 'How It Works')}</span>
                </Fragment>
              )}
            </a>
            <a href="#pricing" className="footer4-link thq-body-small">
              {link4 ?? (
                <Fragment>
                  <span>{t('home.footer.link4', 'Pricing')}</span>
                </Fragment>
              )}
            </a>
            <a href="/support" className="footer4-link thq-body-small">
              {link5 ?? (
                <Fragment>
                  <span>{t('home.footer.link5', 'Support')}</span>
                </Fragment>
              )}
            </a>
          </div>
        </div>

        {/* Bottom Credits & Legal Links */}
        <div className="footer4-bottom">
          <div className="thq-divider-horizontal footer4-divider"></div>
          
          <div className="footer4-bottom-row">
            <span className="footer4-copyright thq-body-small">
              © {currentYear} Mercadito AI. All rights reserved.
            </span>

            <div className="footer4-legal-links">
              <span className="footer4-legal-link thq-body-small">
                {privacyLink ?? (
                  <Fragment>
                    <span>{t('home.footer.privacy', 'Privacy Policy')}</span>
                  </Fragment>
                )}
              </span>
              <span className="footer4-legal-link thq-body-small">
                {termsLink ?? (
                  <Fragment>
                    <span>{t('home.footer.terms', 'Terms of Service')}</span>
                  </Fragment>
                )}
              </span>
              <span className="footer4-legal-link thq-body-small">
                {cookiesLink ?? (
                  <Fragment>
                    <span>{t('home.footer.cookies', 'Cookies')}</span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>

      </div>
    </footer>
  )
}

Footer4.propTypes = {
  link1: PropTypes.element,
  link2: PropTypes.element,
  link3: PropTypes.element,
  link4: PropTypes.element,
  link5: PropTypes.element,
  termsLink: PropTypes.element,
  cookiesLink: PropTypes.element,
  privacyLink: PropTypes.element,
  logoAlt: PropTypes.string,
  logoSrc: PropTypes.string,
}

export default Footer4